// extracted by mini-css-extract-plugin
export default {"colorSchemes":"ColorSchemeInput_colorSchemes__95MyH"};